import "./assets/index.css"

import { createApp } from "vue"
import { createPinia } from "pinia"

import * as Sentry from "@sentry/vue";

import App from "./App.vue"
import router from "./router"

const app = createApp(App)
app.config.globalProperties.window = window

Sentry.init({
	app,
	dsn: "https://f12c2e5308db44453ed07721c2da8338@o304431.ingest.us.sentry.io/4508487734919168",
	enabled: import.meta.env.MODE === "production",
	integrations: [
		Sentry.captureConsoleIntegration({
			levels: ["error",],
		}),
		Sentry.extraErrorDataIntegration(),
	],
	tracesSampleRate: 0,
});

app.use(createPinia())
app.use(router)

app.mount("#app");
